<template>
  <div v-if="application.agreement"
       class="mb-10">

    <div class="border pt-4 pb-2 px-4 mb-6">
      <div class="flex justify-between items-center">
        <h3 class="font-medium">{{ $lang.app.ADDITIONAL_AGREEMENT }}</h3>
      </div>
      <div class="pt-3">
        <div v-for="additional in application.agreement.additionalAgreements"
             :key="additional.id"
             class="bg-blue-50 border border-blue-400 p-4 mb-3">
          <div class="md:flex md:items-start">
            <div class="md:w-1/3">
              <label class="block text-gray-700 pr-4"> {{ $lang.app.FILE }} </label>
            </div>
            <div class="md:w-2/3">
              <div class="flex justify-between">
                <div class="cursor-pointer text-blue-500 font-medium"
                     @click="openFile(additional.id, additional.lastFile?.file?.id)">
                  {{ additional.lastFile?.file?.filename }}
                </div>

                <div>
                  <div class="text-green-400 text-right font-medium text-sm">{{ $lang.app[additionalAgreementStatusesGetLabelRefByValue(additional.status)] }}</div>
                  <Actions v-if="additional.status === additionalAgreementStatusesGetValueByKey('ON_CONFIRM')" class="mt-2"
                           :application="application"
                           :actions="application.actions"
                           :additional="additional"/>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader v-if="loading" class="my-5"/>
    <div v-else class="w-full docs__pdf">
      <iframe :src="agreementPdfFile"
          allowfullscreen
          height="100%"
          width="100%"
      ></iframe>
    </div>
  </div>
</template>
<script>
import applicationApi from "../../../api/employee/application"
import Actions from "./additional-agreement/Actions.vue";
import {
  getValueByKey as additionalAgreementStatusesGetValueByKey,
  getLabelRefByValue as additionalAgreementStatusesGetLabelRefByValue
} from "../../../helpers/constants/additionalAgreementStatuses";

export default {
  components: {
    Actions
  },
  props: {
    application: Object
  },
  data() {
    return {
      loading: false,
      agreementPdfFile: null,
    }
  },
  created() {
    this.getFile()
  },
  methods: {
    additionalAgreementStatusesGetValueByKey,
    additionalAgreementStatusesGetLabelRefByValue,
    getFile() {
      this.loading = true
      applicationApi
        .getApplicationAgreementFile(
            this.application.id,
            this.application.agreement.id,
            this.application.agreement.lastAgreementFile.file.id)
        .then(({ data }) => {
          this.agreementPdfFile = `data:application/pdf;base64,${data.base64}`;
        })
        .catch((error) => {
          this.$snotify.error(error);
        }).finally(() => {
          this.loading = false
      });
    },
    openFile(additionalId, fileId) {
      this.$emitter.emit('open-loader-modal')
      applicationApi.getApplicationAdditionalAgreementFile(
          this.application.id,
          this.application.agreement.id,
          additionalId,
          fileId
      )
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
  }
}
</script>